import { useMutation } from '@apollo/client';
import { gql } from '__generated__/gql';
import { FC, useState } from 'react';

import Button from 'primitives/Button';
import { Dialog, DialogActions, DialogPanel, DialogTitle } from 'primitives/Dialog';
import TextArea from 'primitives/TextArea';

import ErrorMessage from 'components/ErrorMessage';

const REJECT_UNIT_TRANSFER_REQUEST_MUTATION = gql(`
  mutation RejectUnitTransferRequest($id: ID!, $reason: String!) {
    rejectUnitTransferRequest(id: $id, reason: $reason) {
      id
      status
      rejectedAt
      rejectionReason
    }
  }
`);

const RejectUnitTransferRequestButton: FC<{ id: string; disabled?: boolean }> = ({
  id,
  disabled,
}) => {
  const [showDialog, toggleDialog] = useState(false);
  const [reason, setReason] = useState('');
  const [rejectUnitTransferRequest, { loading, error }] = useMutation(
    REJECT_UNIT_TRANSFER_REQUEST_MUTATION
  );

  return (
    <>
      <Button variant="secondary" onClick={() => toggleDialog(true)} disabled={disabled}>
        Reject
      </Button>
      <Dialog open={showDialog} onClose={() => toggleDialog(false)}>
        <DialogPanel>
          <DialogTitle>Reject Transfer Request</DialogTitle>
          <TextArea
            label="Reason"
            value={reason}
            onChange={e => setReason(e.target.value)}
            fullWidth
          />
          {error && <ErrorMessage error={error} type="alert" />}
          <DialogActions>
            <Button variant="secondary" onClick={() => toggleDialog(false)}>
              Cancel
            </Button>
            <Button
              loading={loading}
              disabled={!reason}
              onClick={() =>
                rejectUnitTransferRequest({ variables: { id, reason } }).then(() => {
                  toggleDialog(false);
                  setReason('');
                })
              }
            >
              Reject
            </Button>
          </DialogActions>
        </DialogPanel>
      </Dialog>
    </>
  );
};

export default RejectUnitTransferRequestButton;
